import { render, staticRenderFns } from "./CommandAssistant.vue?vue&type=template&id=b9c48cb8&scoped=true&"
import script from "./CommandAssistant.vue?vue&type=script&lang=js&"
export * from "./CommandAssistant.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistant.vue?vue&type=style&index=0&id=b9c48cb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c48cb8",
  null
  
)

export default component.exports